import React from 'react';
import PropTypes from 'prop-types';
import Night from './nightNumber/NightNumber';
import styles from './NumberOfNights.module.scss';

const NumberOfNights = ({title, nights, currentNight, disabledNights, nightSelectHandler, disableAll}) => {
    return (
        <div className={styles.container}>
            <div>{title}</div>
            <div className={styles.nightsContainer}>
                {nights.map(nightNr => (
                    <Night key={nightNr}
                           clickHandler={() => nightSelectHandler(nightNr)}
                           selected={currentNight === nightNr}
                           disabled={disableAll || disabledNights.includes(nightNr)}>
                        {nightNr}
                    </Night>
                ))}
            </div>
        </div>
    );
};

NumberOfNights.propTypes = {
    title: PropTypes.string,
    nights: PropTypes.array,
    currentNight: PropTypes.number,
    disabledNights: PropTypes.array,
    nightSelectHandler: PropTypes.func,
    disableAll: PropTypes.bool,
};

NumberOfNights.defaultProps = {
    title: 'Choose how many nights',
    nights: [1, 2, 3, 4, 5, 6, 7],
    currentNight: null,
    disabledNights: [],
    nightSelectHandler: () => null,
    disableAll: false
};

export default NumberOfNights;